export const DASHBOARD_TOUR_ID = 'patient-dashboard'

export const DASHBOARD_ONBOARDING_STEPS = [
  {
    title: 'Este é o painel clínico',
    body: 'Aqui o plantão inteiro cabe numa olhada. Os números de cima, a curva do coração e o feed contam o que a equipe lançou.',
  },
  {
    target: '[data-onboarding="dashboard-calendar"]',
    title: 'Voltar no tempo',
    body: 'O calendário escolhe até que dia você quer olhar. Limpa a data e o painel volta para o agora.',
  },
  {
    target: '[data-onboarding="dashboard-kpis"]',
    title: 'Os números do dia',
    body: 'Sinais alterados, evoluções de hoje e prescrições ativas ficam nestes cartões. Eles resumem a casa sem abrir prontuário por prontuário.',
  },
  {
    target: '[data-onboarding="dashboard-shifts"]',
    title: 'Ver os plantões',
    body: 'O cartão Plantões abertos é um botão. Clica nele e aparece quem está na casa agora: o paciente, a equipe ao lado e uma busca para achar a pessoa. Não é só o número.',
  },
  {
    target: '[data-onboarding="dashboard-altered"]',
    title: 'Sinais alterados',
    body: 'Este cartão abre do mesmo jeito. Lá dentro está o resumo: a foto de quem alterou, o que saiu do eixo e o número. Febre, oxigênio, pressão ou coração.',
  },
  {
    target: '[data-onboarding="dashboard-hydration"]',
    title: 'A água da casa',
    body: 'O meio velocímetro mostra a média de litros de hoje contra a meta. Ao lado, a semana: o traço forte é a meta e o azul bebê é o que foi oferecido.',
  },
  {
    target: '[data-onboarding="dashboard-heart"]',
    title: 'O coração do paciente',
    body: 'A curva de frequência segue o paciente escolhido. Ela tem a mesma altura das outras curvas, sem esticar o desenho.',
  },
  {
    target: '[data-onboarding="dashboard-feed"]',
    title: 'O que acabou de acontecer',
    body: 'O feed começa pelo mais recente. Role para baixo e ele busca só o que veio antes, sem carregar o histórico inteiro de uma vez.',
  },
  {
    target: '[data-onboarding="dashboard-charts"]',
    title: 'Febre, oxigênio, pressão e glicemia',
    body: 'As quatro curvas acompanham o mesmo paciente. Toque num cartão lá embaixo, ou no avatar flutuante, para trocar quem está na tela.',
  },
  {
    target: '[data-onboarding="dashboard-roster"]',
    title: 'Os pacientes do dia',
    body: 'Cada cartão mostra leito, dor e os últimos sinais. Abrir o prontuário leva você para o cuidado daquela pessoa.',
  },
  {
    target: '[data-onboarding="dashboard-filter"]',
    title: 'Trocar de paciente',
    body: 'O avatar flutuante escolhe de quem são as curvas. No celular ele fica redondo, pertinho do canto.',
  },
]
